import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
  otp: Yup.string()
    .required("OTP is required")
    .matches(
      /^(\d\s{3}){5}\d$/,
      'OTP should be in the format: "1   2   3   4   5   6"',
    ),
});
